import { render, staticRenderFns } from "./organizationManagement.vue?vue&type=template&id=1ee7bbfe&scoped=true&"
import script from "./organizationManagement.vue?vue&type=script&lang=js&"
export * from "./organizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./organizationManagement.vue?vue&type=style&index=0&id=1ee7bbfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7bbfe",
  null
  
)

export default component.exports